





















import {Vue, Component} from 'vue-property-decorator';
import DomainsCloaking from './forms/cloaking.vue';
import DomainsTracking from './forms/tracking.vue';


@Component({
  components: {
    DomainsTracking,
    DomainsCloaking,
  }
})
export default class Domains extends Vue {
  active: number | null = null;

  get tabs() {
    return [
      {
        label: this.t('Tracking'),
        key: 'tracking',
      },
      {
        label: this.t('Cloaking'),
        key: 'cloaking',
      },
    ]
  }
}
